resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function FormatMoney() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [AnimateNumeric];
  this.declaredClass = null;

  this.cents = true;
  this.optionalDecimals = false;
  this.hasCurrencySymbol = true;
  this.currencySymbol = '$';

  // Classes
  this._classes = {
    class: 'format-money',
    currency: 'format-money__currency',
    dollars: 'format-money__dollars',
    cents: 'format-money__cents'
  };

  // create elements
  this.$currency = $('<span>'+ this.currencySymbol +'</span>');
  this.$dollars = $('<span></span>');
  this.$cents = $('<sup></sup>');

  // add classes
  this.$currency.addClass(this._classes.currency);
  this.$dollars.addClass(this._classes.dollars);
  this.$cents.addClass(this._classes.cents);

  this.init = function() {
    // Setup the input
    this.$node = $(this.node);
    this.$node.addClass(this._classes.class);

    // setup masking value
    this.maskCallback = function(value) {
      var $markup = $('<div></div>');

      // format value
      value = Formatters.formatMoney(value, {
        noCurrencySymbol: true,
        optionalDecimals: this.optionalDecimals
      });
      value = value.split('.');

      // fill html with data
      this.$dollars.text(value[0]);
      this.$cents.text('.' + value[1]);

      // create return string and return it

      $markup.append(this.$dollars);
      if (this.hasCurrencySymbol) $markup.prepend(this.$currency);
      if (this.cents) $markup.append(this.$cents);

      return $markup.html();
    };

    this._super();
  };

  this.initAllReady = function() {
    this._super();
  };

  this.destroy = function() {
    this._super();
  };
}
